import api from "../../Http/global-vars";
import { LocationFormData } from "../../repositories/user/LocationFormData";
import { FETCH_ABOUT_ADMIN, FETCH_ABOUT_FRONT } from "../types";

export const fetchAbouts = () => {
  return async (
    dispatch: (arg0: { type: string; payload: LocationFormData }) => void
  ) => {
    const config = {
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("userToken")}`,
      },
    };
    const token = window.localStorage.getItem("userToken");

    const url = api + "about/";

    if (token) {
      await fetch(url, config)
        .then(async (res) => {
          const data = await res.json();
          dispatch({
            type: FETCH_ABOUT_ADMIN,
            payload: data.results,
          });
        })
        .catch((error) => console.log("error", error?.response));
    }
  };
};

export const fetchAboutsFront = () => {
  return async (
    dispatch: (arg0: { type: string; payload: LocationFormData }) => void
  ) => {
    const url = api + "about/";

    await fetch(url)
      .then(async (res) => {
        const data = await res.json();
        dispatch({
          type: FETCH_ABOUT_FRONT,
          payload: data.results,
        });
      })
      .catch((error) => console.log("error", error?.response));
  };
};
